import { render } from "./OtherPlayer.vue?vue&type=template&id=4b3108c2&ts=true"
import script from "./OtherPlayer.vue?vue&type=script&lang=ts"
export * from "./OtherPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__